module.exports = __webpack_public_path__ + "img/HC2010-152.a49f5481.jpg";